import { CSSProperties } from '@mui/material/styles/createTypography';
import { Box, ThemeProvider } from '@mui/system';
import { Container, Typography } from '@mui/material';
import theme from '../../src/style-system/theme';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import Image from 'next/image';

import { CarouselType } from '@utils/types';
import { animationduration } from '@utils/data';

export enum ColorVariant {
  GARAMMASALA_COLOR = 'garamMasala.main',
  CINNAMON_COLOR = 'cinnamon.main',
}
interface CarouselProps {
  carouselContent: CarouselType[];
  isTitleFirst?: boolean;
  subtitleColor?: ColorVariant;
  titleColor?: ColorVariant;
  swipeable?: boolean;
}

const CarouselComponet = ({
  carouselContent,
  isTitleFirst,
  titleColor,
  subtitleColor = ColorVariant.GARAMMASALA_COLOR,
  swipeable = true,
}: CarouselProps) => {
  const indicatorStyles: CSSProperties = {
    background: '#F7C144',
    width: 10,
    height: 10,
    display: 'inline-block',
    margin: '0 8px',
    borderRadius: '50%',
    border: '1px solid #D46A19',
  };

  return (
    <>
      <ThemeProvider theme={theme}>
        <Container maxWidth="xl" disableGutters>
          <Carousel
            autoPlay
            infiniteLoop
            swipeable={swipeable}
            interval={animationduration}
            showStatus={false}
            showThumbs={false}
            showArrows={false}
            renderIndicator={(onClickHandler, isSelected, index, label) => {
              if (isSelected) {
                return (
                  <li
                    style={{
                      ...indicatorStyles,
                      background: '#D46A19',
                    }}
                    aria-label={`Selected: ${label} ${index + 1}`}
                    title={`Selected: ${label} ${index + 1}`}
                  />
                );
              }
              return (
                <li
                  style={indicatorStyles}
                  onClick={onClickHandler}
                  onKeyDown={onClickHandler}
                  value={index}
                  key={index}
                  role="button"
                  tabIndex={0}
                  title={`${label} ${index + 1}`}
                  aria-label={`${label} ${index + 1}`}
                />
              );
            }}
          >
            {carouselContent.map((content) => {
              return (
                <Box
                  key={content.id}
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  {isTitleFirst ? (
                    <Typography
                      variant="h3"
                      align="center"
                      color={titleColor || 'garamMasala.main'}
                      mb="30px"
                    >
                      {content.title}
                    </Typography>
                  ) : null}
                  <Box
                    sx={{
                      position: 'relative',
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      width: content?.width ? `${content?.width}px` : '253px',
                      height: '253px',
                      marginBottom: '30px',
                      borderRadius: content.alt === 'chopChef' ? '50%' : '0',
                      overflow: content.alt === 'chopChef' ? 'hidden' : 'auto',
                    }}
                  >
                    <Image
                      src={content.icon}
                      alt={content.alt}
                      objectFit="contain"
                      layout="fill"
                      priority={content.priority}
                      placeholder={content.blurUrl ? 'blur' : 'empty'}
                      blurDataURL={content.blurUrl}
                    />
                  </Box>
                  {!isTitleFirst ? (
                    <Typography
                      variant="h3"
                      align="center"
                      color="cinnamon.main"
                    >
                      {content.title}
                    </Typography>
                  ) : null}
                  <Typography
                    variant="body1"
                    align="center"
                    color={subtitleColor}
                    mt={isTitleFirst ? 2 : 0}
                    mb={5}
                    sx={{
                      maxWidth: '250px',
                      [theme.breakpoints.up('sm')]: {
                        maxWidth: '320px',
                      },
                      [theme.breakpoints.up('md')]: {
                        maxWidth: '360px',
                      },
                    }}
                  >
                    {content.subtitle}
                  </Typography>
                </Box>
              );
            })}
          </Carousel>
        </Container>
      </ThemeProvider>
    </>
  );
};

export default CarouselComponet;
